import { notification } from "antd";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { QUERY_NAME, SERVICES } from "@lhd/constants";
import axios from "@lhd/libs/axios";
import { getCompanyId } from "@lhd/utility";
import { Projects } from "@lhd/types";

export const useFetchProjects = (
  page: number,
  pageSize: number,
  filterParams: any,
) => {
  const companyId = getCompanyId();
  return useQuery(
    [QUERY_NAME.PROJECTS, companyId, page, pageSize, filterParams],
    () =>
      axios({
        method: "get",
        url: SERVICES.PROJECTS,
        params: {
          page,
          per_page: pageSize,
          ...filterParams,
          "q[company_id_eq]": companyId,
          current_company_id: companyId,
        },
      }).then((res) => ({
        data: res.data as Projects[],
        meta: {
          total: res.headers["x-total"] || 0,
          total_page: res.headers["x-total-pages"] || 0,
        },
      })),
    // {
    //   cacheTime: Infinity,
    //   staleTime: Infinity,
    // },
  );
};

export const useFetchOneProject = (projectId: any) => {
  const companyId = getCompanyId();
  return useQuery(
    [QUERY_NAME.PROJECT, projectId],
    () =>
      axios({
        method: "get",
        url: `${SERVICES.PROJECTS}/${projectId}`,
        params: {
          current_company_id: companyId,
        },
      }).then((res) => res.data as Projects),
    {
      cacheTime: Infinity,
      staleTime: Infinity,
      enabled: !!projectId,
    },
  );
};

export const useSubmitProject = () => {
  const queryClient = useQueryClient();
  const companyId = getCompanyId();

  return useMutation(
    ({ payload, projectId }: any) =>
      axios({
        method: projectId ? "patch" : "post",
        url: projectId
          ? `${SERVICES.PROJECTS}/${projectId}`
          : SERVICES.PROJECTS,
        data: payload,
        params: {
          current_company_id: companyId,
        },
      }),
    {
      onSuccess() {
        queryClient.invalidateQueries([QUERY_NAME.PROJECTS]);
        queryClient.invalidateQueries([QUERY_NAME.PROJECT]);
        notification["success"]({
          message: "保存しました",
        });
      },
    },
  );
};

export const useSubmitSaveProjects = () => {
  const queryClient = useQueryClient();
  const companyId = getCompanyId();

  return useMutation(
    ({ payload }: any) =>
      axios({
        method: "post",
        url: SERVICES.PROJECTS_SAVE,
        data: payload,
        params: {
          current_company_id: companyId,
        },
      }),
    {
      onSuccess(e) {
        queryClient.invalidateQueries([QUERY_NAME.PROJECTS]);
        if (e?.data?.errors?.length > 0) {
          notification["error"]({
            message: e?.data?.errors?.[0],
          });
        } else {
          // notification["success"]({
          //   message: "保存しました",
          // });
        }
      },
    },
  );
};

export const useDeleteProject = () => {
  const queryClient = useQueryClient();
  const companyId = getCompanyId();

  return useMutation(
    ({ projectId }: any) =>
      axios({
        method: "delete",
        url: `${SERVICES.PROJECTS}/${projectId}`,
        params: {
          current_company_id: companyId,
        },
      }),
    {
      onSuccess() {
        queryClient.invalidateQueries([QUERY_NAME.PROJECTS]);
        notification["success"]({
          message: "保存しました",
        });
      },
    },
  );
};

export const useDeleteMultiplProject = () => {
  const queryClient = useQueryClient();
  const companyId = getCompanyId();

  return useMutation(
    ({ listProjectIds }: any) => {
      const formData = new FormData();
      listProjectIds.forEach((id: any) => {
        formData.append(`delete_ids[]`, id);
      });
      formData.append("current_company_id", companyId.toString());
      return axios({
        method: "post",
        data: formData,
        url: `${SERVICES.PROJECTS}/delete_multiple`,
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "application/json",
        },
      });
    },
    {
      onSuccess() {
        queryClient.invalidateQueries([QUERY_NAME.PROJECTS]);
        notification["success"]({
          message: "保存しました",
        });
      },
    },
  );
};
